var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
__export(exports, {
  BORDER: () => BORDER,
  BORDER_BOTTOM: () => BORDER_BOTTOM,
  BORDER_LEFT: () => BORDER_LEFT,
  BORDER_SURROUND: () => BORDER_SURROUND,
  BORDER_TOP: () => BORDER_TOP,
  BORDER_TOP_BOTTOM: () => BORDER_TOP_BOTTOM,
  BORDER_UNSET_TOP_BOTTOM: () => BORDER_UNSET_TOP_BOTTOM,
  FORM_KEY: () => FORM_KEY,
  HAPTICS_FEEDBACK: () => HAPTICS_FEEDBACK
});
const BORDER = "van-hairline";
const BORDER_TOP = `${BORDER}--top`;
const BORDER_LEFT = `${BORDER}--left`;
const BORDER_BOTTOM = `${BORDER}--bottom`;
const BORDER_SURROUND = `${BORDER}--surround`;
const BORDER_TOP_BOTTOM = `${BORDER}--top-bottom`;
const BORDER_UNSET_TOP_BOTTOM = `${BORDER}-unset--top-bottom`;
const HAPTICS_FEEDBACK = "van-haptics-feedback";
const FORM_KEY = Symbol("van-form");
